module.exports = __webpack_public_path__ + "img/McBean-2.7c34a865.png";